import { render, staticRenderFns } from "./NewsItemView.vue?vue&type=template&id=1f6241e1&"
import script from "./NewsItemView.vue?vue&type=script&lang=js&"
export * from "./NewsItemView.vue?vue&type=script&lang=js&"
import style0 from "./NewsItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports